import { useField } from "formik";
import React from "react";

import { DynamicObjectListField, FieldHeaderProps, FieldStateProps, TextField } from "../";
import { useSetFieldTouched } from "../useSetFieldTouched";
import * as styles from "./DynamicTextListField.module.css";

type DynamicTextListFieldProps = Readonly<{
  name: string;
  buttonLabel: string;
  placeholder?: string;
  disableAddNewUrlButton?: boolean;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const DynamicTextListField = (props: DynamicTextListFieldProps) => {
  const { isSaving, placeholder, ariaLabel } = props;
  const [field] = useField(props);
  useSetFieldTouched(`${field.name}.0`);

  const renderTextField = (name: string, index: number) => (
    <div className={styles.textFieldContainer} aria-label={name}>
      <TextField
        placeholder={placeholder}
        name={`${name}.${index}`}
        isSaving={isSaving}
        onlyInternalElements={true}
        ariaLabel={ariaLabel}
      />
    </div>
  );

  return <DynamicObjectListField {...props} renderChild={renderTextField}></DynamicObjectListField>;
};
